import { useCurrentUserAccessRole } from "Hooks/useCurrentUserAccessRole";
import { AccessRoleCodes } from "Models/AccessRoleCodes";

// Returns true for both Admin and AdminLite. AdminLite is the read-only/export-only
// developer role and mirrors Admin everywhere this hook decides what UI to render;
// write actions remain gated by useCheckPermission against the relevant permission flag.
export const useIsCurrentUserAdmin = () => {
  const userRole = useCurrentUserAccessRole();

  return (
    userRole === AccessRoleCodes.Admin || userRole === AccessRoleCodes.AdminLite
  );
};
